export interface TeamMember {
    name: string;
    role: string;
    image: string;
    socials: {
        icon: string;
        url: string;
    }[];
}       

export const teamData: TeamMember[] = [
    {
        name: "Ms. Neha Verma",
        role: "Instructor",
        image: "/images/teams/c4.png",
        socials: [
            { icon: "fa-facebook-f", url: "#" },
            { icon: "fa-x-twitter", url: "#" },
            { icon: "fa-linkedin-in", url: "#" },
        ],
    },
    {
        name: "Dr. Anjali Sharma",
        role: "Instructor",
        image: "/images/teams/c1.png",
        socials: [
            { icon: "fa-facebook-f", url: "#" },
            { icon: "fa-x-twitter", url: "#" },
            { icon: "fa-linkedin-in", url: "#" },
        ],
    },
    {
        name: "Ms. Neha Verma",
        role: "Instructor",
        image: "/images/teams/c2.png",
        socials: [
            { icon: "fa-facebook-f", url: "#" },
            { icon: "fa-x-twitter", url: "#" },
            { icon: "fa-linkedin-in", url: "#" },
        ],
    },
    {
        name: "Dr. Anjali Mehra",
        role: "Instructor",
        image: "/images/teams/c3.png",
        socials: [
            { icon: "fa-facebook-f", url: "#" },
            { icon: "fa-x-twitter", url: "#" },
            { icon: "fa-linkedin-in", url: "#" },
        ],
    },
    {
        name: "Aleid Batsaikhan",
        role: "Instructor",
        image: "/images/teams/team1.jpg",
        socials: [
            { icon: "fa-facebook-f", url: "#" },
            { icon: "fa-x-twitter", url: "#" },
            { icon: "fa-linkedin-in", url: "#" },
        ],
    },
    {
        name: "Erica Castellanos",
        role: "Instructor",
        image: "/images/teams/team2.jpg",
        socials: [
            { icon: "fa-facebook-f", url: "#" },
            { icon: "fa-x-twitter", url: "#" },
            { icon: "fa-linkedin-in", url: "#" },
        ],
    },
    {
        name: "Cillian Czeslaw",
        role: "Instructor",
        image: "/images/teams/team3.jpg",
        socials: [
            { icon: "fa-facebook-f", url: "#" },
            { icon: "fa-x-twitter", url: "#" },
            { icon: "fa-linkedin-in", url: "#" },
        ],
    },
    {
        name: "Daithi Ermenegildo",
        role: "Instructor",
        image: "/images/teams/team4.jpg",
        socials: [
            { icon: "fa-facebook-f", url: "#" },
            { icon: "fa-x-twitter", url: "#" },
            { icon: "fa-linkedin-in", url: "#" },
        ],
    },
    {
        name: "Aleid Batsaikhan",
        role: "Instructor",
        image: "/images/teams/team1.jpg",
        socials: [
            { icon: "fa-facebook-f", url: "#" },
            { icon: "fa-x-twitter", url: "#" },
            { icon: "fa-linkedin-in", url: "#" },
        ],
    },
    {
        name: "Erica Castellanos",
        role: "Instructor",
        image: "/images/teams/team2.jpg",
        socials: [
            { icon: "fa-facebook-f", url: "#" },
            { icon: "fa-x-twitter", url: "#" },
            { icon: "fa-linkedin-in", url: "#" },
        ],
    },
    {
        name: "Cillian Czeslaw",
        role: "Instructor",
        image: "/images/teams/team3.jpg",
        socials: [
            { icon: "fa-facebook-f", url: "#" },
            { icon: "fa-x-twitter", url: "#" },
            { icon: "fa-linkedin-in", url: "#" },
        ],
    },
    {
        name: "Daithi Ermenegildo",
        role: "Instructor",
        image: "/images/teams/team4.jpg",
        socials: [
            { icon: "fa-facebook-f", url: "#" },
            { icon: "fa-x-twitter", url: "#" },
            { icon: "fa-linkedin-in", url: "#" },
        ],
    },
];